import { all } from "redux-saga/effects";
import getCarSaga from "../cars";
import getDefinitions from "../definitions";
import languageSaga from "../language/saga";
import offerSaga from "../offer";

export function* rootSaga() {
  yield all([...getCarSaga, ...languageSaga, ...getDefinitions, ...offerSaga]);
}
